import { render } from "./Favorite.vue?vue&type=template&id=6d0378f4"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"

import "./Favorite.vue?vue&type=style&index=0&id=6d0378f4&lang=css"
script.render = render

export default script